import React from 'react';
import { CustomAccordion } from '../../../shared';
import {
    KpiDefinition,
    KpiDefinitionReplimune,
    PimicotinibDTCDefinition,
    ReplimuneDTCDefinition,
} from '../../../../constants';
import Notes from '../../../shared/notes';
import { useSelector } from 'react-redux';

const WebMetricsNote = () => {
    const { company } = useSelector((state) => state.company);
    const noteDataItems = {
        185: KpiDefinitionReplimune,
        61: ReplimuneDTCDefinition,
        94: KpiDefinition.filter((item) => item.key !== 'Bounce rate'),
        165: ReplimuneDTCDefinition,
        150: ReplimuneDTCDefinition,
        default: KpiDefinition,
    };
    const noteData = noteDataItems[company.id] || noteDataItems.default;
    return (
        <CustomAccordion
            acoordianDetailsBackground="bg-white"
            acoordianDetailsPadding="padding-t-8-b-16"
            component={<Notes Definition={noteData} />}
            title="Metrics Information"
        />
    );
};

export default WebMetricsNote;
